export class CarouselReel extends HTMLElement {
  connectedCallback() {
    this.classList.add('glide__slides');
  }

  disconnectedCallback() {
    this.classList.add('glide__slides');
  }
}